import { cn } from '@sparkai/utils'

import { getBinColorFromScale } from './getBinColorFromScale'

interface ConfusionMatrixBinProps {
  value: number
  totalAmount: number
  onClick?: () => void
}

export function ConfusionMatrixBin({ value, totalAmount, onClick }: ConfusionMatrixBinProps) {
  const ratio = totalAmount === 0 ? 0 : value / totalAmount
  const Component = onClick ? 'button' : 'div'

  return (
    <Component
      className={cn(
        'flex min-h-[120px] items-center rounded-md p-6 text-gray-900 transition-all duration-200',
        getBinColorFromScale(ratio),
        onClick && 'cursor-pointer'
      )}
      {...(onClick ? { type: 'button' as const, onClick } : {})}
    >
      <div className='text-2xl leading-none font-medium'>
        {formatNumber(value)}
        <span className='ml-2 text-xs'>{formatPercent(ratio * 100)}</span>
      </div>
    </Component>
  )
}

const formatPercent = new Intl.NumberFormat('en-US', {
  style: 'unit',
  unit: 'percent',
  maximumFractionDigits: 1,
}).format

const formatNumber = new Intl.NumberFormat('en-US', {
  notation: 'standard',
  compactDisplay: 'short',
  maximumFractionDigits: 2,
  useGrouping: true,
}).format
